import './new-violation.scss';

import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";
import { useQyCreateViolation } from "@core/query/violation.query";
import { ViolationFormRule, ViolationFormSchema } from "@core/form/form.rule";
import { violationFormDefault } from "@core/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import HeaderContent from "@shared/ui/header-content/header-content";
import FormViolation from "../form-violation/form-violation";

export function NewViolation() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateViolation } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Violation is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addViolation, isLoading: isCreating } =
    useQyCreateViolation(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<ViolationFormSchema>({
    defaultValues: violationFormDefault,
    resolver: zodResolver(ViolationFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: ViolationFormSchema) => {
    const formData = mapCreateViolation(form);
    addViolation(formData);
  };
  const handleValidateError = (err: FieldErrors<ViolationFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="Violation" className="violation">
      <HeaderContent
        title="New Violation"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
            <FormViolation />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewViolation;